/**
* IBM Confidential
* Licensed Materials - Property of IBM
* (C) Copyright IBM Corp. 2020, 2024 All Rights Reserved.
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
* */

import React from 'react';
import PropTypes from 'prop-types';
import { Column } from '@carbon/react';

var CardLabeledItem = function CardLabeledItem(_ref) {
  var label = _ref.label,
    value = _ref.value,
    xlg = _ref.xlg,
    _ref$lg = _ref.lg,
    lg = _ref$lg === void 0 ? 4 : _ref$lg,
    _ref$md = _ref.md,
    md = _ref$md === void 0 ? 4 : _ref$md,
    _ref$sm = _ref.sm,
    sm = _ref$sm === void 0 ? 4 : _ref$sm;
  return /*#__PURE__*/React.createElement(Column, {
    xlg: xlg,
    lg: lg,
    md: md,
    sm: sm,
    key: label
  }, /*#__PURE__*/React.createElement("div", {
    className: "cpc--card__stacked-labeled-rows-label"
  }, label), /*#__PURE__*/React.createElement("div", {
    className: "cpc--card__stacked-labeled-rows-value"
  }, value));
};
CardLabeledItem.propTypes = {
  /**
   * The content to be rendered as a label.
   */
  label: PropTypes.node.isRequired,
  /**
   * The content to be rendered under the given label.
   */
  value: PropTypes.node.isRequired,
  /**
   * Specify column span for the `xlg` breakpoint.
   */
  xlg: PropTypes.number,
  /**
   * Specify column span for the `lg` breakpoint.
   */
  lg: PropTypes.number,
  /**
   * Specify column span for the `md` breakpoint.
   */
  md: PropTypes.number,
  /**
   * Specify column span for the `sm` breakpoint.
   */
  sm: PropTypes.number
};
var CardLabeledItem$1 = CardLabeledItem;

export { CardLabeledItem$1 as default };
